import React from 'react';
import './Automatisation.css';

const Automatisation = () => {
  return (
    <div className="auto-auto">
      <div className="automatisme">
        <h2>Automatisation</h2>
        <p>Spécialistes de l’automatisation industrielle, nous concevons, mettons en œuvre et maintenons des systèmes automatisés performants adaptés aux besoins de chaque secteur d’activité.</p>
      </div>
    </div>
  );
};

export default Automatisation;